module.exports = "/shared/fonts/Futura/web/FtraMd-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./src/ui/fonts/Futura/web/FtraMd-webfont.eot
// module id = 12
// module chunks = 13